import { toast } from 'react-toastify';
import { SubmissionError } from 'redux-form';

import Api from 'lib/api';

const api = Api.getInstance();

const ns = 'app/corporations/';

export const LOAD_START = ns + 'LOAD_START';
export const LOAD_SUCCESS = ns + 'LOAD_SUCCESS';
export const LOAD_FAILURE = ns + 'LOAD_FAILURE';

export const VIEW_START = ns + 'VIEW_START';
export const VIEW_SUCCESS = ns + 'VIEW_SUCCESS';
export const VIEW_FAILURE = ns + 'VIEW_FAILURE';

export const SAVE_START = ns + 'SAVE_START';
export const SAVE_SUCCESS = ns + 'SAVE_SUCCESS';
export const SAVE_FAILURE = ns + 'SAVE_FAILURE';

export const DELETE_START = ns + 'DELETE_START';
export const DELETE_FAILURE = ns + 'DELETE_FAILURE';
export const DELETE_SUCCESS = ns + 'DELETE_SUCCESS';

export const USERS_LOADED = ns + 'USERS_LOADED';

/*

export const REQUEST_START = ns + 'REQUEST_START';
export const REQUEST_SUCCESS = ns + 'REQUEST_SUCCESS';
export const REQUEST_FAILURE = ns + 'REQUEST_FAILURE';
*/

export function getCorporations(query) {
  return async dispatch => {
    dispatch({
      type: LOAD_START
    });

    try {
      const response = await api.get('corporations', { params: query });
      const { data } = response;

      if (data.success) {
        dispatch({
          type: LOAD_SUCCESS,
          payload: data.data
        });
      } else {
        dispatch({
          type: LOAD_FAILURE,
          payload: response
        });
      }
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: LOAD_FAILURE,
        payload: response
      });
    }
  };
}

export function deleteCorporation(id, callback) {
  return async dispatch => {
    dispatch({
      type: DELETE_START
    });

    try {
      const response = await api.post(
        `users/delete-organization/corporation/${id}`
      );

      const { data } = response;

      if (data.success) {
        toast.success('Corporation deleted successfully!');
        dispatch({
          type: DELETE_SUCCESS,
          payload: data
        });
        callback();
      } else {
        toast.error('Unable to delete corporation!');
        dispatch({
          type: DELETE_FAILURE,
          payload: data
        });
      }
    } catch (error) {
      toast.error(error.message || 'Unable to delete corporation!');
      dispatch({
        type: DELETE_FAILURE,
        payload: error.response
      });
    }
  };
}

export function view(id) {
  return async dispatch => {
    dispatch({
      type: VIEW_START
    });

    try {
      const response = await api.get(`corporations/${id}`);
      const { data } = response;

      if (data.success) {
        dispatch({
          type: VIEW_SUCCESS,
          payload: data.data
        });
      } else {
        toast.error('Unable to retrieve corporation data.');
        dispatch({
          tyype: VIEW_FAILURE
        });
      }
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: VIEW_FAILURE,
        payload: response
      });
    }
  };
}

export function save(corp, history, reset) {
  return async dispatch => {
    dispatch({
      type: SAVE_START
    });

    try {
      let response;
      if (corp.id) {
        response = await api.put(`corporations/${corp.id}`, corp);
      } else {
        response = await api.post('corporations', corp);
      }

      const { data } = response;

      if (data.success) {
        toast.success('Corporation saved!');

        dispatch({
          type: SAVE_SUCCESS
        });

        reset();

        history.push('/corporations');
      } else {
        dispatch({
          type: SAVE_FAILURE
        });
        toast.error('Unable to update corporation.');
      }
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: SAVE_FAILURE
      });

      if (response.errors) {
        let throwErrors = {};
        for (let field in response.errors) {
          throwErrors[field] = Object.values(response.errors[field]).join(', ');
        }

        throw new SubmissionError(throwErrors);
      }
    }
  };
}

export function loadUsers() {
  return async dispatch => {
    const response = await api.get('users/list');
    const { data } = response;

    if (data.success) {
      dispatch({
        type: USERS_LOADED,
        payload: data.users
      });
    }
  };
}

/*
export function request(ask) {
  return async dispatch => {
    dispatch({
      type: REQUEST_START,
      payload: ask.id
    });

    try {
      const response = await api.get(`partnerships/request/${ask.id}`);
      const { data } = response;

      if (data.success) {
        if (data.partnership && data.partnership[0]) {
          toast.success('Partnership requested.');
        } else {
          toast.success('Partnership request canceled.');
        }

        dispatch({
          type: REQUEST_SUCCESS,
          payload: data.partnership
        });
      } else {
        dispatch({
          type: REQUEST_FAILURE
        });

        toast.error('Unable to complete request.');
      }
    } catch (error) {
      let response = error;

      if (error.response && error.response.data) {
        response = error.response.data.data;
      }

      if (response) {
        toast.error(response.message);
      } else {
        toast.error('An error occured. Please try again.');
      }

      dispatch({
        type: REQUEST_FAILURE
      });
    }
  };
}
*/



// WEBPACK FOOTER //
// ./src/components/app/corporations/actions.js